import { html } from 'lit';
import { AlertCircle } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-alert-circle')
export class PdsIconAlertCircle extends PdsIcon {
  @state()
  icon = AlertCircle;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
